import { blue, red, green, yellow, black, white, grey } from './Colors';
export const LightThemePalette = {
    common: {
        black: black,
        white: white,
    },
    background: {
        default: grey[90],
    },
    primary: {
        main: blue['45'],
    },
    secondary: {
        main: black,
    },
    error: {
        main: red['45'],
    },
    success: {
        main: green['45'],
    },
    warning: {
        main: yellow['45'],
    },
    info: {
        main: blue['45'],
    },
};
export const DarkThemePalette = {
    mode: 'dark',
    common: {
        black: black,
        white: white,
    },
    background: {
        default: grey[5],
        paper: grey[10],
    },
    primary: {
        main: blue['50'],
    },
    secondary: {
        main: white,
    },
    error: {
        main: red['50'],
    },
    success: {
        main: green['50'],
    },
    warning: {
        main: yellow['50'],
    },
    info: {
        main: blue['50'],
    },
};
